import React, { Component } from 'react'
import { connect } from 'react-redux'
import { signOut } from '../../../../../store/Actions/authActions/authActions'
import {Link } from 'react-router-dom';
import NotificationsIcon from '@material-ui/icons/Notifications';
import AccountCircle from '@material-ui/icons/AccountCircle'
import ExitToAppIcon from '@material-ui/icons/ExitToApp'
import Badge from '@material-ui/core/Badge';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';

class MenuTop extends Component {
 signOut= (e) => {
   this.props.signOut()
 }
  render() {
    const {appBarLink} = this.props
    return (
      <div>
        <Link to='/notifications' style={{color: 'unset'}} >
        
            <IconButton style={{color: appBarLink }}>
              <Badge badgeContent={4} color="secondary">
                <Tooltip title="Notifications">
                  <NotificationsIcon />
                </Tooltip>
               </Badge>
            </IconButton>
          
        </Link>  
        <Link to='/profilepage' style={{color: 'unset'}}>
          <IconButton style={{color: appBarLink }}>
            <Tooltip title="Profile">
              <AccountCircle />
            </Tooltip>
          </IconButton>
        </Link> 
        <IconButton style={{color: appBarLink }} onClick={this.signOut}>
          <Tooltip title="Sign Out">
            <ExitToAppIcon  /> 
          </Tooltip>
        </IconButton>
      </div>
    )
  }
}

export default connect(null, {signOut})(MenuTop)
